export const ScreenSizes = {
  Desktop: 0,
  Mobile: 1,
  MobileSmall: 2
};

export const WizardSteps = {
  AboutMe: 1,
  Question: 2,
  AdvisorSelection: 3,
  Payment: 4,
  WhatsNext: 5
};

export const Keys = {
  Enter: 'Enter',
  Escape: 'Escape',
  ArrowUp: 'ArrowUp',
  ArrowDown: 'ArrowDown',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  Tab: 'Tab',
  Space: ' ',
  Backspace: 'Backspace',
  Delete: 'Delete',
  Home: 'Home',
  End: 'End',
  PageUp: 'PageUp',
  PageDown: 'PageDown',
  Shift: 'Shift',
  Control: 'Control',
  Alt: 'Alt',
  Meta: 'Meta'
};
